module.exports = __webpack_public_path__ + "img/two-dimensional_4.d0eb0b1e.png";